import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IUser } from '@shared/interfaces';
import { Subscription } from 'rxjs';
import { GuardService } from '@shared/services/guard.service';

@Component({
    selector: 'app-welcome-banner',
    templateUrl: './welcome-banner.component.html',
    styleUrls: ['./welcome-banner.component.scss'],
    standalone: false
})
export class WelcomeBannerComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() header: string;
    currentUser: IUser;
    subscription: Subscription;
    _name: string;

    constructor(
        private guardService: GuardService,
        private changeDetection: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.subscription = this.guardService.currentUserSubscribable.subscribe(e => (this.currentUser = e));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
